import type { GetObligationImpactsByParentIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetObligationImpactsByParentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationImpactsByParentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetObligationImpactsByParentIdArgs = {
  parentId: string;
};

export const useLazyGetObligationImpactsByParentId = createLazyQueryHook<
  UseLazyGetObligationImpactsByParentIdArgs,
  GetObligationImpactsByParentIdResponseRow[],
  GetObligationImpactsByParentIdQuery
>({
  trpcQuery: (client, { parentId }) =>
    client.frontend.obligationImpact.getByParentId.query({ parentId }),
  mapTrpcDataToGraphQL: (data) => ({ obligation_impact: data || [] }),
  graphqlDocument: GetObligationImpactsByParentIdDocument,
  graphqlVariables: ({ parentId }) => ({ _eq: parentId }),
});
